export const STATUS_LABELS = {
  new: 'Novo',
  contacted: 'Contatado',
  qualified: 'Qualificado',
  discarded: 'Descartado',
  won: 'Convertido',
};
export const PRIORITY_LABELS = {
  high: 'Alta',
  medium: 'Média',
  low: 'Baixa',
  review: 'Conferir dados',
  unscored: 'Sem avaliação',
};
export function observedAt(value) {
  return value ? new Date(value).toLocaleString('pt-BR') : 'Data não registrada';
}
export function Priority({ lead }) {
  const tone =
    lead.priority === 'high'
      ? 'bg-emerald-50 text-emerald-800'
      : lead.priority === 'review'
        ? 'bg-amber-50 text-amber-800'
        : 'bg-slate-100 text-slate-700';
  return (
    <span className={`inline-flex rounded px-2 py-1 text-xs font-medium ${tone}`}>
      {PRIORITY_LABELS[lead.priority]}
      {lead.score !== null ? ` · ${lead.score}/100` : ''}
    </span>
  );
}
export function Website({ lead }) {
  return lead.websiteUrl ? (
    <a
      href={lead.websiteUrl}
      target="_blank"
      rel="noreferrer"
      className="text-brand-700 hover:underline break-all"
    >
      {lead.primary_domain || 'Abrir site'}
    </a>
  ) : (
    <span className="text-slate-500">Site não encontrado — conferir</span>
  );
}
